import Vue from 'vue'
import Router from 'vue-router'
import HomeWork from './home-work'
// import App from '@/App'

// 临时演示用, 后期需要删除
import Demo from '@/demo/Demo'
import NotFound from '@/views/404/NotFound'

import Index from '../views/home/Index'

// 客户页面
const Customer = () => import(/* webpackChunkName: 'customer' */ '@/views/customer/Customer')
const CustomerList = () => import(/* webpackChunkName: 'customer' */ '@/views/customer/list/CustomerList')
const CustomerEdit = () => import(/* webpackChunkName: 'customer' */ '@/views/customer/edit/CustomerEdit')
const CustomerAdd = () => import(/* webpackChunkName: 'customer' */ '@/views/customer/add/CustomerAdd')
// 代理商客户页面
const agentCustomerList = () => import(/* webpackChunkName: 'customer' */ '@/views/agent-customer/list/CustomerList')
const agentCustomerEdit = () => import(/* webpackChunkName: 'customer' */ '@/views/agent-customer/edit/CustomerEdit')

// 考试页面
const Exam = () => import(/* webpackChunkName: 'exam' */ '@/views/exam/Exam')
const ExamList = () => import(/* webpackChunkName: 'exam' */ '@/views/exam/list/ExamList')
const ExamAdd = () => import(/* webpackChunkName: 'exam' */ '@/views/exam/add/ExamAdd')
const ExamEdit = () => import(/* webpackChunkName: 'exam' */ '@/views/exam/edit/ExamEdit')
const ExamDelete = () => import(/* webpackChunkName: 'exam' */ '@/views/exam/delete/ExamDelete')
const ReadPaperTask = () => import(/* webpackChunkName: 'exam' */ '@/views/exam/task/ReadPaperTask')
const ReadPaperTaskForSchool = () => import(/* webpackChunkName: 'exam' */ '@/views/exam/task/ReadPaperTaskForSchool')
const Monitor = () => import(/* webpackChunkName: 'monitor' */ '@/views/monitor/Monitor')
const MonitorScan = () => import(/* webpackChunkName: 'monitor' */ '@/views/monitor/scan/MonitorScan')
const MonitorMark = () => import(/* webpackChunkName: 'monitor' */ '@/views/monitor/mark/MonitorMark')
const MonitorStudent = () => import(/* webpackChunkName: 'monitor' */ '@/views/monitor/student/MonitorStudent')
const ImportCandidate = () => import(/* webpackChunkName: 'ImportCandidate' */ '@/views/exam/ImportCandidate')
const GenerateScoreDialog = () => import(/* webpackChunkName: 'GenerateScoreDialog' */ '@/views/exam/generate-score/GenerateScoreDialog')
const SetOmrAnswerScore = () => import(/* webpackChunkName: 'SetOmrAnswerScore' */ '@/views/exam/omr-answer-score/SetOmrAnswerScore')
const ResetPwd = () => import(/* webpackChunkName: 'ResetPwd' */ '@/views/admin/user/ResetPwd')
const OmrAnswerScorePreview = () => import(/* webpackChunkName: 'OmrAnswerScorePreview' */ '@/views/exam/omr-answer-score/OmrAnswerScorePreview')
// 评卷参数设置
const ReadParam = () => import(/* webpackChunkName: 'ReadParam' */ '@/views/exam/task/read-param/ReadParam')
// 主观题画块
const CollectPaperBlock = () => import(/* webpackChunkName: 'CollectPaperBlock' */ '@/views/exam/collect-paper-block/CollectPaperBlock')

// 主观题画块
const CollectScanBlock = () => import(/* webpackChunkName: 'CollectPaperBlock' */ '@/views/exam/collect-paper-block/CollectScanBlock')

// 开启试评
const OpenPreMark = () => import(/* webpackChunkName: 'OpenPreMark' */ '@/views/exam/open-pre-mark/OpenPreMark')
// 开启正评
const OpenMark = () => import(/* webpackChunkName: 'OpenMark' */ '@/views/exam/open-mark/OpenMark')
// 开启正评，学校
const OpenMarkForSchool = () => import(/* webpackChunkName: 'OpenMark' */ '@/views/exam/open-mark/OpenMarkForSchool')
// 机构流程收集题卡信息
const CardCollection = () => import(/* webpackChunkName: 'OpenMark' */ '@/views/exam/task/card-collection/CardCollection')
// 学校流程收集题卡信息
const CardCollectionForSchool = () => import(/* webpackChunkName: 'OpenMark' */ '@/views/exam/task/card-collection/CardCollectionForSchool')
// 学校单科成绩生成
const GenerateSubjectScore = () => import(/* webpackChunkName: 'OpenMark' */ '@/views/exam/task/generate-subject-score/GenerateSubjectScore')
// 主观题识别查看
const CheckViewItem = () => import(/* webpackChunkName: 'OpenMark' */ '@/views/exam/card-online/CheckViewItem')

// 双向细目表录入
const ItemKnowledgePoints = () => import(/* webpackChunkName: 'OpenMark' */ '@/views/exam/item-point-input/ItemKnowledgePoints')
// 双向细目表相关画块
const SetItemAnswerArea = () => import(/* webpackChunkName: 'OpenMark' */ '@/views/exam/item-point-input/SetItemAnswerArea')

// 评卷教师选择评卷题目界面
const ExaminationList = () => import(/* webpackChunkName: 'OpenMark' */ '@/views/exam/examination-list/ExaminationList')

// 学校考试页面
// 考试页面
const ExamSchool = () => import(/* webpackChunkName: 'exam' */ '@/views/exam-school/ExamSchool')
const ExamAddSchool = () => import(/* webpackChunkName: 'exam' */ '@/views/exam-school/add/ExamAddSchool')
const ExamEditSchool = () => import(/* webpackChunkName: 'exam' */ '@/views/exam-school/edit/ExamEditSchool')

// 教师页面
const Teacher = () => import(/* webpackChunkName: 'teacher' */ '@/views/teacher/Teacher')
const TeacherManage = () => import(/* webpackChunkName: 'teacher' */ '@/views/teacher/TeacherManage')
const TeacherAdd = () => import(/* webpackChunkName: 'teacher' */ '@/views/teacher/add/TeacherAdd')
const TeacherEdit = () => import(/* webpackChunkName: 'teacher' */ '@/views/teacher/edit/TeacherEdit')
const ImportTeacher = () => import(/* webpackChunkName: 'teacher' */ '@/views/teacher/ImportTeacher')

// 选考科目修改，查看
const StudentSubjectView = () => import(/* webpackChunkName: 'teacher' */ '@/views/exam/task/generate-subject-score/StudentSubjectView')

// 成绩页面
const Score = () => import(/* webpackChunkName: 'score' */ '@/views/score/Score')
const ScoreList = () => import(/* webpackChunkName: 'score' */ '@/views/score/ScoreList')
const ScoreView = () => import(/* webpackChunkName: 'score' */ '@/views/score/ScoreView')
const ImageView = () => import(/* webpackChunkName: 'score' */ '@/views/score/ImageView')
// const ReportPrivilegeDia = () => import(/* webpackChunkName: 'score' */ '@/views/score/ReportPrivilegeDia')

// 机构信息管理
const Org = () => import(/* webpackChunkName: 'Org' */ '@/views/org/Org')
const OrgInfo = () => import(/* webpackChunkName: 'Org' */ '@/views/org/info/OrgInfo')
const SchoolInfo = () => import(/* webpackChunkName: 'Org' */ '@/views/org/info/SchoolInfo')
const MemberInfo = () => import(/* webpackChunkName: 'Org' */ '@/views/org/member/MemberInfo')

// 学生管理
const StudentClasses = () => import(/* webpackChunkName: 'ClassManager' */ '@/views/student/StudentClasses')
// 学生管理 班级学生列表
const StudentList = () => import(/* webpackChunkName: 'ClassManager' */ '@/views/student/StudentList')
// 教学班
const ClassTeaching = () => import(/* webpackChunkName: 'ClassManager' */ '@/views/class/teaching/ClassTeaching')
// 教学班
const ClassAdmin = () => import(/* webpackChunkName: 'ClassManager' */ '@/views/class/admin/ClassAdmin')

// 任务管理
const Task = () => import(/* webpackChunkName: 'Task' */ '@/views/task/Task')
const AdminTask = () => import(/* webpackChunkName: 'Task' */ '@/views/task/AdminTask')

// 用户信息管理
const User = () => import(/* webpackChunkName: 'User' */ '@/views/user/User')
const ImportUserPhoto = () => import(/* webpackChunkName: 'ImportUserPhoto' */ '@/views/user/ImportUserPhoto')
const UserEdit = () => import(/* webpackChunkName: 'UserEdit' */ '@/views/user/UserEdit')

// 组卷
const Paper = () => import(/* webpackChunkName: 'ImportUserPhoto' */ '@/views/paper/Paper')
const addPaper = () => import(/* webpackChunkName: 'ImportUserPhoto' */ '@/views/paper/Add')
const KnowledgePoint = () => import(/* webpackChunkName: 'ImportUserPhoto' */ '@/views/paper/KnowledgePoint')
const Save = () => import(/* webpackChunkName: 'ImportUserPhoto' */ '@/views/paper/Save')
const Preview = () => import(/* webpackChunkName: 'ImportUserPhoto' */ '@/views/paper/Preview')
const UserPaper = () => import(/* webpackChunkName: 'ImportUserPhoto' */ '@/views/paper/UserPaper')
const Analysis = () => import(/* webpackChunkName: 'ImportUserPhoto' */ '@/views/paper/Analysis')

// 评卷
const Read = () => import(/* webpackChunkName: 'ImportUserPhoto' */ '@/views/read/Read')
const ReadNormal = () => import(/* webpackChunkName: 'ImportUserPhoto' */ '@/views/read/ReadNormal')
const ReadProblem = () => import(/* webpackChunkName: 'ImportUserPhoto' */ '@/views/read/ReadProblem')
const ReadFinal = () => import(/* webpackChunkName: 'ImportUserPhoto' */ '@/views/read/ReadFinal')
const ReadCheck = () => import(/* webpackChunkName: 'ImportUserPhoto' */ '@/views/read/ReadCheck')

// 在线题卡
const CardList = () => import(/* webpackChunkName: 'ImportUserPhoto' */ '@/views/card/list/CardList')

// 管理员科目管理
const ClassSubject = () => import(/* webpackChunkName: 'ImportUserPhoto' */ '@/views/admin/subject/ClassSubject')
const ExamSubject = () => import(/* webpackChunkName: 'ImportUserPhoto' */ '@/views/admin/subject/ExamSubject') // 引进layout组件

// 财务对账管理
const Finance = () => import(/* webpackChunkName: 'ImportUserPhoto' */ '@/views/admin/finance/index')

// 销售管理
const Sale = () => import(/* webpackChunkName: 'ImportUserPhoto' */ '@/views/admin/sale/index')

// 希沃单点登录
const seewoOAuthLogin = () => import(/* webpackChunkName: 'teacher' */ '@/views/login/seewo')

// 帮助手册
const help = () => import(/* webpackChunkName: 'teacher' */ '@/views/help/index')

// 校验
const Verify = () => import(/* webpackChunkName: 'ImportUserPhoto' */ '@/views/verify/Verify')
const VerifySubject = () => import(/* webpackChunkName: 'ImportUserPhoto' */ '@/views/verify/VerifySubject')
const VerifyObjective = () => import(/* webpackChunkName: 'ImportUserPhoto' */ '@/views/verify/VerifyObjective')

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Index,
      redirect: 'exam',
      children: [{
        path: '/exam',
        component: Exam,
        children: [
          {
            path: '/',
            name: 'ExamList',
            meta: { title: '考试', topMenu: '考试' },
            component: ExamList
          },
          {
            path: 'list',
            name: 'ExamList',
            meta: { title: '考试', topMenu: '考试' },
            component: ExamList
          },
          {
            path: 'add', // 创建考试
            name: 'ExamAdd',
            meta: { title: '创建考试', topMenu: '考试' },
            component: ExamAdd
          },
          {
            path: 'edit/:examId', // 修改考试
            name: 'ExamEdit',
            meta: { title: '修改考试', topMenu: '考试' },
            component: ExamEdit
          },
          {
            path: 'delete/:examId', // 删除考试
            name: 'ExamDelete',
            meta: { title: '删除考试', topMenu: '考试' },
            component: ExamDelete
          },
          {
            path: 'task/:examId/:subjectId', // 任务分配
            name: 'ReadPaperTask',
            meta: { title: '任务分配', topMenu: '考试' },
            component: ReadPaperTask
          },
          {
            path: 'task-school/:examId/:subjectId', // 任务分配学校用
            name: 'ReadPaperTaskForSchool',
            meta: { title: '任务分配', topMenu: '考试' },
            component: ReadPaperTaskForSchool
          },
          {
            path: ':examId/:examName/read-param/:subjectId/:subjectName', // 评卷参数设置
            name: 'ReadParam',
            meta: { title: '评卷参数设置', topMenu: '考试' },
            component: ReadParam
          },
          {
            path: 'import-candidate/:examId/:examName', // 导入考生，暂时通过此路径访问
            name: 'ImportCandidate',
            component: ImportCandidate
          },
          {
            path: 'generate-score/:examId', // 出成绩，暂时通过此路径访问
            name: 'GenerateScoreDialog',
            meta: { title: '成绩发布', topMenu: '考试' },
            component: GenerateScoreDialog
          },
          {
            path: 'omr-answer-score/:examId/:examName/:subjectId/:subjectName',
            name: 'SetOmrAnswerScore',
            meta: { title: '设置标答与分值', topMenu: '考试' },
            component: SetOmrAnswerScore
          },
          {
            path: 'omr-answer-score-preview/:examId/:examName/:subjectId/:subjectName',
            name: 'OmrAnswerScorePreview',
            meta: { title: '评卷方案预览', topMenu: '考试' },
            component: OmrAnswerScorePreview
          },
          {
            path: 'open-pre-mark/:examId/:examName/:subjectId/:subjectName',
            name: 'OpenPreMark',
            meta: { title: '开启试评', topMenu: '考试' },
            component: OpenPreMark
          },
          {
            path: 'open-mark/:examId/:examName/:subjectId/:subjectName',
            name: 'OpenMark',
            meta: { title: '开启正评', topMenu: '考试' },
            component: OpenMark
          },
          {
            path: 'open-mark-school/:examId/:examName/:subjectId/:subjectName',
            name: 'OpenMarkForSchool',
            meta: { title: '开启评卷', topMenu: '考试' },
            component: OpenMarkForSchool
          },
          {
            path: 'card-collection/:examId/:examName/:subjectId/:subjectName',
            name: 'CardCollection',
            meta: { title: '收集题卡信息', topMenu: '考试' },
            component: CardCollection
          },
          {
            path: 'card-collection-school/:examId/:examName/:subjectId/:subjectName',
            name: 'CardCollectionForSchool',
            meta: { title: '收集题卡信息', topMenu: '考试' },
            component: CardCollectionForSchool
          },
          {
            path: 'generate-subject-score/:examId/:examName/:subjectId/:subjectName',
            name: 'GenerateSubjectScore',
            meta: { title: '单科成绩上报', topMenu: '考试' },
            component: GenerateSubjectScore
          },
          {
            path: ':examId/:examName/item-knowledge-points/:subjectId/:subjectName',
            name: 'ItemKnowledgePoints',
            meta: { title: '知识点录入', topMenu: '考试' },
            component: ItemKnowledgePoints
          },
          {
            path: 'examination-list/:examName/:subjectName/:gradeName',
            name: 'ExaminationList',
            meta: { title: '评卷题目列表', topMenu: '考试' },
            component: ExaminationList
          }
        ]
      },
      {
        path: '/score',
        component: Score,
        children: [
          {
            path: 'list/:orgId',
            name: 'ScoreList',
            meta: { title: '成绩', topMenu: '成绩' },
            component: ScoreList
          }
        ]
      }]
    },
    {
      path: '/customer',
      component: Index,
      meta: { title: '客户', topMenu: '客户' },
      name: 'customer',
      children: [
        {
          path: '/',
          redirect: 'list'
        },
        {
          path: 'list', // 客户列表
          name: 'customerList',
          meta: { title: '客户', topMenu: '客户' },
          component: CustomerList
        },
        {
          path: 'add', // 客户新增
          meta: { title: '客户新增', topMenu: '客户' },
          name: 'customerAdd',
          component: CustomerAdd
        },
        {
          path: 'edit/:orgId', // 客户新增
          meta: { title: '客户编辑', topMenu: '客户' },
          name: 'customerEdit',
          component: CustomerEdit
        }
      ]
    },
    {
      path: '/finance',
      component: Index,
      meta: { title: '财务对账', topMenu: '财务对账' },
      name: 'finance',
      children: [
        {
          path: '/',
          redirect: 'list'
        },
        {
          path: 'list', // 财务对账列表
          name: 'financeList',
          meta: { title: '财务对账', topMenu: '财务对账' },
          component: Finance
        }
      ]
    },
    {
      path: '/sale',
      component: Index,
      meta: { title: '销售管理', topMenu: '销售管理' },
      name: 'sale',
      children: [
        {
          path: '/',
          redirect: 'list'
        },
        {
          path: 'list', // 销售管理列表
          name: 'SaleList',
          meta: { title: '销售管理', topMenu: '销售管理' },
          component: Sale
        }
      ]
    },
    {
      path: '/agent-customer',
      component: Index,
      meta: { title: '代理商的客户', topMenu: '客户' },
      name: 'agentCustomer',
      children: [
        {
          path: '/',
          redirect: 'list'
        },
        {
          path: 'list', // 客户列表
          name: 'agentCustomerList',
          meta: { title: '代理商的客户列表', topMenu: '客户' },
          component: agentCustomerList
        },
        {
          path: 'edit/:orgId', // 客户新增
          meta: { title: '代理商的客户编辑', topMenu: '客户' },
          name: 'agentCustomerEdit',
          component: agentCustomerEdit
        }
      ]
    },
    {
      path: '/exam-info/:userId/:examId',
      name: 'ExamInfo',
      component: () => import('@/views/exam-info/ExamInfo')
    },
    {
      path: '/collect-paper-block/:examId/:examName/:subjectId/:subjectName',
      name: 'CollectPaperBlock',
      meta: { title: '主观题画块', topMenu: '考试' },
      component: CollectPaperBlock
    },
    {
      path: '/collect-scan-block/:examId/:examName/:subjectId/:subjectName',
      name: 'CollectScanBlock',
      meta: { title: '其他画块信息设置', topMenu: '考试' },
      component: CollectScanBlock
    },
    {
      path: '/set-item-answer-area/:examId/:examName/:subjectId/:subjectName/:type',
      name: 'SetItemAnswerArea',
      meta: { title: '双向细目表画块', topMenu: '考试' },
      component: SetItemAnswerArea
    },
    {
      path: '/exam-school',
      // component : ExamSchool,
      component: Index,
      children: [
        {
          path: '/',
          redirect: 'add'
        },
        {
          path: 'add', // 创建考试
          name: 'ExamAddSchool',
          meta: { title: '创建考试', topMenu: '考试' },
          component: ExamAddSchool
        },
        {
          path: 'edit/:examId', // 编辑考试
          name: 'ExamEditSchool',
          meta: { title: '编辑考试', topMenu: '考试' },
          component: ExamEditSchool
        }
      ]
    },
    {
      path: '/monitor/:examId/:subjectId',
      component: Monitor,
      children: [
        {
          path: 'scan',
          name: 'MonitorScan',
          meta: { title: '扫描监控', topMenu: '考试' },
          component: MonitorScan
        },
        {
          path: 'mark',
          name: 'MonitorMark',
          meta: { title: '评卷监控', topMenu: '考试' },
          component: MonitorMark
        },
        {
          path: 'student',
          name: 'MonitorStudent',
          meta: { title: '考生详情', topMenu: '考试' },
          component: MonitorStudent
        }
      ]
    },
    {
      path: '/teacher',
      component: Index,
      name: 'Teacher',
      meta: { title: '教师', topMenu: '学校信息' },
      redirect: 'teacher/manage',
      children: [
        {
          path: '/',
          redirect: 'manage'
        },
        {
          path: 'manage',
          name: 'TeacherManage',
          meta: { title: '教师列表', topMenu: '学校信息' },
          component: TeacherManage
        },
        {
          path: 'add',
          name: 'TeacherAdd',
          meta: { title: '添加教师', topMenu: '学校信息' },
          component: TeacherAdd
        },
        {
          path: 'edit/:teacherId',
          name: 'TeacherEdit',
          meta: { title: '编辑教师信息', topMenu: '学校信息' },
          component: TeacherEdit
        }, {
          path: 'import',
          name: 'ImportTeacher',
          component: ImportTeacher
        }
      ]
    },
    {
      path: '/student',
      component: Index,
      name: 'Student',
      meta: { title: '学生', topMenu: '学校信息' },
      redirect: 'student/manage',
      children: [
        {
          path: '/',
          redirect: 'manage'
        },
        {
          path: 'manage',
          name: 'StudentClasses',
          meta: { title: '学生管理', topMenu: '学校信息' },
          component: StudentClasses
        },
        {
          path: 'list/:classId/:classCode/:grade/:classType',
          name: 'StudentList',
          meta: { title: '班级学生信息', topMenu: '学校信息' },
          component: StudentList,
          props: true
        }
      ]
    },
    {
      path: '/org/:orgId',
      meta: { title: '基础信息', topMenu: '基础信息' },
      component: Index,
      children: [
        {
          path: '/',
          redirect: 'info'
        },
        {
          path: 'info',
          name: 'OrgInfo',
          meta: { title: '机构信息', topMenu: '基础信息' },
          component: OrgInfo
        },
        {
          path: 'school-info',
          name: 'SchoolInfo',
          meta: { title: '学校信息', topMenu: '学校信息' },
          component: SchoolInfo
        }, {
          path: 'member-info',
          name: 'MemberInfo',
          meta: { title: '用户', topMenu: '基础信息' },
          component: MemberInfo
        }
      ]
    },
    {
      path: '/score',
      component: Score,
      // name: 'Score',
      meta: { title: '成绩', topMenu: '成绩' },
      children: [
        {
          path: 'list/:orgId',
          name: 'ScoreList',
          meta: { title: '成绩列表', topMenu: '成绩' },
          component: ScoreList
        },
        {
          path: 'score-view/:examId',
          name: 'ScoreView',
          meta: { title: '分数查看', topMenu: '成绩' },
          component: ScoreView
        },
        {
          path: 'image-view/:examId',
          name: 'ImageView',
          meta: { title: '图像查看', topMenu: '成绩' },
          component: ImageView
        }
      ]
    },
    {
      path: '/admin',
      // component: () => import(/* webpackChunkName: 'admin' */ '@/views/admin/Admin'),
      component: Index,
      meta: { title: '管理员', topMenu: '管理员' },
      children: [
        {
          path: 'user',
          name: 'AdminUser',
          component: () => import(/* webpackChunkName: 'admin' */ '@/views/admin/user/AdminUser')
        },
        {
          path: 'behavior-record',
          name: 'BehaviorRecord',
          component: () => import(/* webpackChunkName: 'admin' */ '@/views/admin/bahavior-record/BehaviorRecord')
        },
        {
          path: 'exam-list-unrelease',
          name: 'ExamListUnrelease',
          meta: { title: '监控', topMenu: '监控' },
          component: () => import(/* webpackChunkName: 'admin' */ '@/views/admin/exam-list-unrelease/ExamListUnrelease')
        },
        {
          path: 'role',
          name: 'Role',
          meta: { title: '基础信息', topMenu: '基础信息' },
          component: () => import(/* webpackChunkName: 'admin' */ '@/views/admin/Base'),
          children: [{
            path: 'manager',
            name: 'Manager',
            meta: { title: '基础角色', topMenu: '基础信息' },
            component: () => import(/* webpackChunkName: 'admin' */ '@/views/admin/role-manager/RoleManager')
          }]
        },
        {
          path: 'sync',
          name: 'SyncManager',
          component: () => import(/* webpackChunkName: 'admin' */ '@/views/admin/sync/SyncManager')
        },
        {
          path: 'getTempAuthorizeCode',
          name: 'AuthorizeCode',
          meta: { title: '授权码', topMenu: '授权码' },
          component: () => import(/* webpackChunkName: 'admin' */ '@/views/admin/user/TempAuthorizeCode')
        },
        {
          path: 'role',
          component: () => import(/* webpackChunkName: 'admin' */ '@/views/admin/role/Role'),
          children: [
            {
              path: 'add',
              name: 'RoleAdd',
              component: () => import(/* webpackChunkName: 'admin' */ '@/views/admin/role/add/RoleAdd')
            },
            {
              path: 'update/:roleId',
              name: 'RoleUpdate',
              component: () => import(/* webpackChunkName: 'admin' */ '@/views/admin/role/update/RoleUpdate')
            }
          ]
        },
        {
          path: 'agent',
          name: 'Agent',
          meta: { title: '代理商' },
          component: () => import(/* webpackChunkName: 'admin' */ '@/views/admin/Base'),
          children: [
            {
              path: 'list',
              name: 'AgentList',
              meta: { title: '代理商列表', topMenu: '代理商' },
              component: () => import(/* webpackChunkName: 'admin' */ '@/views/admin/agent/AgentManager')
            },
            {
              path: 'add',
              name: 'AgentAdd',
              meta: { title: '增加代理商', topMenu: '代理商' },
              component: () => import(/* webpackChunkName: 'admin' */ '@/views/admin/agent/add/AgentAdd')
            },
            {
              path: 'edit/:agentId',
              name: 'AgentLEdit',
              meta: { title: '编辑代理商', topMenu: '代理商' },
              component: () => import(/* webpackChunkName: 'admin' */ '@/views/admin/agent/edit/AgentEdit')
            }
          ]
        },
        {
          path: 'subject',
          name: 'Subject',
          meta: { title: '科目', topMenu: '基础信息' },
          component: () => import(/* webpackChunkName: 'admin' */ '@/views/admin/Base'),
          children: [
            {
              path: 'class',
              name: 'ClassSubject',
              meta: { title: '课程科目', topMenu: '基础信息' },
              component: ClassSubject
            },
            {
              path: 'exam',
              name: 'ExamSubject',
              meta: { title: '考试科目', topMenu: '基础信息' },
              component: ExamSubject
            }
          ]
        }
      ]
    },
    {
      path: '/class',
      name: 'ClassManage',

      meta: { title: '班级', topMenu: '学校信息' },
      component: Index,
      children: [
        {
          path: '/',
          redirect: 'manage'
        },
        {
          path: 'teaching',
          name: 'teaching',
          meta: { title: '教学班', topMenu: '学校信息' },
          component: ClassTeaching
        },
        {
          path: 'admin',
          name: 'admin',
          meta: { title: '行政班', topMenu: '学校信息' },
          component: ClassAdmin
        }
      ]
    },
    {
      path: '/task',
      name: 'Task',
      meta: { title: '任务列表', topMenu: '' },
      component: Task
    },
    {
      path: '/adminTask',
      name: 'AdminTask',
      meta: { title: '任务列表', topMenu: '' },
      component: AdminTask
    },
    {
      path: '/user',
      name: 'User',
      meta: { title: '个人信息', topMenu: '' },
      component: User,
      children: [
        {
          path: 'import-user-photo',
          name: 'ImportUserPhoto',
          meta: { title: '上传头像', topMenu: '' },
          component: ImportUserPhoto
        },
        {
          path: 'reset-password',
          name: 'ResetPwd',
          meta: { title: '重置密码', topMenu: '' },
          component: ResetPwd
        },
        {
          path: 'edit',
          name: 'UserEdit',
          meta: { title: '个人信息修改', topMenu: '' },
          component: UserEdit
        }
      ]
    },
    {
      path: '/paper/:userId/:orgId/',
      name: 'Paper',
      meta: { title: '组卷', topMenu: '组卷题卡' },
      component: Paper,
      children: [
        {
          path: 'add',
          name: 'Add',
          component: addPaper,
          children: [
            {
              path: 'knowledge-point/:subjectSign',
              name: 'KnowledgePoint',
              meta: { title: '知识点', topMenu: '组卷题卡' },
              component: KnowledgePoint
            }
          ]
        },
        {
          path: 'save',
          name: 'Save',
          component: Save,
          children: [
            {
              path: 'preview/:subjectEnName/:subjectName',
              name: 'Preview',
              meta: { title: '试卷预览', topMenu: '组卷题卡' },
              component: Preview
            },
            {
              path: 'analysis/:subjectEnName/:subjectName',
              name: 'Analysis',
              meta: { title: '试卷分析', topMenu: '组卷题卡' },
              component: Analysis
            }
          ]
        },
        {
          path: 'list',
          name: 'UserPaper',
          component: Index,
          children: [
            {
              path: 'UserPaperList',
              name: 'UserPaperList',
              meta: { title: '我的卷库', topMenu: '组卷题卡' },
              component: UserPaper
            }
          ]
        }
      ]
    },
    {
      path: '/read/',
      name: 'Read',
      component: Read,
      meta: { title: '评卷', topMenu: '' },
      children: [
        {
          path: 'read-normal/:examId/:examName/:subjectId/:subjectName/:itemId/:examType',
          name: 'ReadNormal',
          meta: { title: '评卷', topMenu: '' },
          component: ReadNormal
        },
        {
          path: 'read-problem/:examId/:examName/:subjectId/:subjectName/:itemId/:examType',
          name: 'ReadProblem',
          meta: { title: '评卷', topMenu: '' },
          component: ReadProblem
        },
        {
          path: 'read-final/:examId/:examName/:subjectId/:subjectName/:itemId/:examType',
          name: 'ReadFinal',
          meta: { title: '评卷', topMenu: '' },
          component: ReadFinal
        },
        {
          path: 'read-check/:examId/:examName/:subjectId/:subjectName/:itemId/:examType',
          name: 'ReadCheck',
          meta: { title: '评卷', topMenu: '' },
          component: ReadCheck
        }
      ]
    },
    {
      path: '/verify/',
      name: 'Verify',
      component: Verify,
      meta: { title: '校验', topMenu: '' },
      children: [
        {
          path: 'objective/:examId/:examName/:subjectId/:subjectName/:checkType',
          name: 'VerifyObjective',
          meta: { title: '客观题校验', topMenu: '' },
          component: VerifyObjective
        },
        {
          path: 'subject/:examId/:examName/:subjectId/:subjectName/:checkType',
          name: 'VerifySubject',
          meta: { title: '主观题校验', topMenu: '' },
          component: VerifySubject
        }
      ]
    },
    {
      path: '/card/',
      name: 'card',
      component: Index,
      children: [
        {
          path: 'list',
          name: 'CardList',
          component: CardList,
          meta: { title: '我的题卡', topMenu: '组卷题卡' }
        }
      ]
    },
    {
      path: '/exam/check-view-item/:userId/:examId/:examName/:subjectId/:subjectName',
      name: 'CheckViewItem',
      meta: { title: '题目核查', topMenu: '题目核查' },
      component: CheckViewItem
    },
    {
      path: '/exam/check-student-subject/:examId',
      name: 'StudentSubjectView',
      meta: { title: '学生选考科目编辑', topMenu: '学生选考科目编辑' },
      component: StudentSubjectView
    },
    {
      path: '/oauth/seewo',
      name: 'oauthSeewo',
      meta: { title: '登录', topMenu: '登录' },
      component: seewoOAuthLogin
    },
    {
      path: '/help',
      name: 'help',
      meta: { title: '登录', topMenu: '登录' },
      component: help
    },
    HomeWork,
    {
      path: '*',
      component: NotFound
    }
  ]
})
export const asyncRouterMap = [{
  path: '/demo',
  name: 'Demo',
  component: Demo,
  meta: { title: '权限测试', privilegs: ['demo'] }
}]
export const constantRouterMap = [
  { path: '/404', component: NotFound, hidden: true }
]



// WEBPACK FOOTER //
// ./src/router/index.js